const indexItems = [
  { icon: 'ri-movie-line', label: '悬疑剧场', desc: '高分悬疑剧集精选', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-history-line', label: '古装大剧', desc: '热门古装权谋巨制', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-heart-line', label: '甜宠爱情', desc: '都市甜宠浪漫合集', color: 'bg-pink-100 text-pink-600' },
  { icon: 'ri-rocket-line', label: '动作大片', desc: '好莱坞动作精选', color: 'bg-orange-100 text-orange-600' },
  { icon: 'ri-emotion-laugh-line', label: '喜剧专区', desc: '国产喜剧爆笑不断', color: 'bg-green-100 text-green-600' },
  { icon: 'ri-earth-line', label: '纪录片', desc: 'BBC国家地理精选', color: 'bg-blue-100 text-blue-600' },
  { icon: 'ri-ghost-line', label: '动漫番剧', desc: '国漫日漫一网打尽', color: 'bg-purple-100 text-purple-600' },
  { icon: 'ri-live-line', label: '综艺热播', desc: '热门综艺全程高能', color: 'bg-amber-100 text-amber-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          热门专题
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">精选影视分类，快速找到你想看的</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer group"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 whitespace-nowrap">{item.label}</h3>
                <p className="text-xs text-foreground-500 font-body truncate">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}